import { render, staticRenderFns } from "./view404.vue?vue&type=template&id=225dce18"
import script from "./view404.vue?vue&type=script&lang=js"
export * from "./view404.vue?vue&type=script&lang=js"
import style0 from "./view404.vue?vue&type=style&index=0&id=225dce18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports